export default {
  token: state => {
    return state.token
  },
  user: state => {
    return state.user
  },
  projects: state => {
    return state.userInfo.projects
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js